import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
    cacheSize: 0, // ← Disabling cache
    override: {
        classGroups: {
            "font-size": [
                {
                    text: [
                        "xxxs",
                        "xxs",
                        "sm",
                        "md",
                        "ml",
                        "lg",
                        "xl",
                        "2xl",
                        "3xl",
                        "zing-9-14",
                        "zing-12-18",
                        "zing-14-18",
                        "zing-16-20",
                        "zing-16-22",
                        "zing-18-26",
                        "zing-24-32",
                        "zing-32-40",
                        "zing-32-130",
                        "zing-40-48",
                        "zing-60-76",
                        "zing-80-96",
                    ],
                },
            ],
        },
    },
});

export default customTwMerge;
